import { render, staticRenderFns } from "./questionType3.vue?vue&type=template&id=707e6a08"
import script from "./questionType3.vue?vue&type=script&lang=js"
export * from "./questionType3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports